import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from '@reach/router';
import qs from 'query-string';

import isMobile from '~/utils/new-is-mobile';

import PcDeviceForRelease from './asset/PcDeviceForRelease.png';
import mobileDevice from './asset/mobileDevice.png';

import { BGWrap, EventApplyBtn } from './styled';
import isEmpty from '~/utils/valid/is-empty';

const CleanPcComponent = () => {

  const navigate = useNavigate();
  const location = useLocation();

  const { pathname, search } = location;
  const parse = qs.parse(search);

  const [deviceType, setDeviceType] = useState('')

  useEffect(() => {
    initInfo();
  }, [])

  function initInfo() {
    delete parse.auth_key;
    navigate(isEmpty(parse) ? pathname : pathname + `?${qs.stringify(parse)}`, { replace: true });
    setDeviceType(isMobile() ? "mobile" : "pc");
  }

  function render() {
    if (deviceType === 'mobile') {
      return (
        <BGWrap width={710} height={3129} imgUrl={mobileDevice}>
          <EventApplyBtn as={"a"} href={"https://dabang.app.link/9jDlXPjRfzb"} />
        </BGWrap>
      );

    } else if ('pc') {
      return (
        <BGWrap width={710} height={3520} imgUrl={PcDeviceForRelease} />
      );
      
    } else {
      return null;
    }
  }

  return (
    <>
     {render()}
    </>
  );
};

export default CleanPcComponent;
